import { subtract } from '../utils/math';

/**
 * When the overpayment form allocates extra funds to suspense, the "upcoming" amount
 * already includes the next statement that hasn't been billed yet. Subtract that
 * unbilled portion so we don't double-count it as suspense.
 */
export const getAdjustedSuspense = (
  additionalSuspense: number | undefined,
  totalUpcomingAmountRemainingFromBorrower: number,
  totalAmountRemainingFromBorrower: number,
) =>
  Math.max(
    0,
    subtract(
      additionalSuspense ?? 0,
      // Goes negative when the amount due exceeds the upcoming total (interest-due-at-payoff), which would inflate the suspense
      Math.max(0, subtract(totalUpcomingAmountRemainingFromBorrower, totalAmountRemainingFromBorrower)),
    ),
  );
